module.exports = __webpack_public_path__ + "img/umbrella_with_rain_drops.c6de9092.gif";